import React from 'react';
import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { formatDate } from 'utils';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { segmentType } from 'utils/handbooks/pushManagerHandbooks';

function SegmentsTable({
  items,
  loading,
  current,
  pageSize,
  totalRows,
  filters = {},
  onRowClick,
  onChange,
  onFilter,
}) {
  const { start_date, end_date } = filters;

  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Тип',
      dataIndex: 'type',
      key: 'type',
      render: (type) => segmentType[type],
    },
    {
      title: 'Дата создания',
      dataIndex: 'created_date',
      key: 'created_date',
      render: (date) => formatDate(date),
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[start_date, end_date]}
            onFilterChange={([start, end]) => {
              onFilter({ start_date: start, end_date: end });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={start_date && end_date} />,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { SegmentsTable };
